export default __webpack_public_path__ + "static/media/forward-icon.b842c274.svg";